function CardRichMedia({
  imageClassName,
  provider,
  richMediaUrl,
  richMediaPosterUrl,
  customData
}: {
  imageClassName: string
  provider: string
  richMediaUrl: string
  richMediaPosterUrl: string
  customData: {
    type: string
    name: string
    s3Key?: string
  }
}) {
  const isVideo = customData.type === 'mp4'
  const isAudio = customData.type === 'mp3' || customData.type === 'audio'
  const isMediaProvider =
    provider === 's3' || provider === 'external' || provider === 'giphy'
  const shouldRenderVideo = isMediaProvider && isVideo
  const shouldRenderAudio = isMediaProvider && isAudio

  if (shouldRenderVideo) {
    return (
      // eslint-disable-next-line jsx-a11y/media-has-caption
      <video
        width="100%"
        controls
        muted
        playsInline
        preload="metadata"
        poster={richMediaPosterUrl}>
        <source src={richMediaUrl} type="video/mp4" />
      </video>
    )
  }

  if (shouldRenderAudio) {
    return (
      // eslint-disable-next-line jsx-a11y/media-has-caption
      <audio controls preload="metadata" className="w-full">
        <source src={richMediaUrl} type="audio/mpeg" />
      </audio>
    )
  }

  return (
    <img
      width="100%"
      src={richMediaUrl}
      alt="Rich media content"
      loading="lazy"
      className={imageClassName}
    />
  )
}

export default CardRichMedia
